import React from 'react';
import Contacts from '../Components/contact-page';

function Contact() {
  return (
    <div className="bg-[#E8FBFF] min-h-screen ">
      <Contacts />
    </div>
  );
}

export default Contact;
